import {Group} from 'src/design/atoms/Group';
import {Text} from 'src/design/atoms/Text';
import {Tooltip} from 'src/design/atoms/Tooltip';
import {IconInfoCircle} from '@tabler/icons-react';
import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';

/**
 * Label node for a metadata field: the plain label, plus an info icon
 * carrying `labelTooltip` when the field defines one.
 *
 * Returns the bare string when there is no tooltip so fields that never opt in
 * keep rendering exactly as before.
 */
export function renderFieldLabel(field: IFormFieldV2): React.ReactNode {
  if (!field.labelTooltip) return field.label;

  return (
    <Group gap={4} wrap="nowrap" component="span" display="inline-flex">
      <Text size="sm" span>
        {field.label}
      </Text>
      <Tooltip
        label={field.labelTooltip}
        multiline
        w={320}
        withArrow
        events={{hover: true, focus: true, touch: true}}>
        <Text
          span
          c="dimmed"
          display="inline-flex"
          aria-label={`${field.label} help`}
          role="img"
          tabIndex={0}
          style={{cursor: 'help', verticalAlign: 'middle'}}>
          <IconInfoCircle size={14} />
        </Text>
      </Tooltip>
    </Group>
  );
}
